import jQuery from 'jquery';
import {trackingService} from "../tracking/services/tracking";
import cookieConsentOverlayWidget from "../widgets/cookie-consent-overlay-widget";

cookieConsentOverlayWidget();

window.consentChangedCbs = window.consentChangedCbs || [];

const defaultOptions = {
	controls: true,
	autoplay: 'any',
	preload: 'none',
	aspectRatio: '16:9',
	autoSetup: false,
	fluid: true,
	responsive: true,
	techOrder: ['html5']
};

async function initPlayer(playerElm, idPrefix, options) {

	const {default: videojs} = await import('video.js');
	const plugins = await Promise.all([import('videojs-youtube'), import('./videojs-resolution-switcher')]);

	const ControlBar = videojs.getComponent('ControlBar');
	ControlBar.prototype.options_.children = ControlBar.prototype.options_.children.filter(child => child !== 'pictureInPictureToggle');
	const Player = videojs.getComponent('Player');

	function getRandomInt(min, max) {
		return Math.floor(Math.random() * (max - min)) + min;
	}

	const randomInt = getRandomInt(0, 100000);
	const playerId = idPrefix + '-' + randomInt;

	playerElm.attr('id', playerId);
	playerElm.addClass('video-js vjs-default-skin vjs-big-play-button vjs-big-play-centered');

	const combinedOptions = jQuery.extend(true, {}, defaultOptions, options);
	const videojsInstance = videojs(playerId, combinedOptions);

	const deferred = jQuery.Deferred();
	deferred.resolve(videojsInstance);

	return deferred.promise();
}

function initVideoPlayer(playerElm, idPrefix, videoId, additionalOptions){
	const deferred = jQuery.Deferred();

	const options = {
		autoplay: false,
		plugins: {
			videoJsResolutionSwitcher: {
				'default': 'low',
				'dynamicLabel': true
			}
		},
		...(additionalOptions ?? {}),
	};

	const playerPromise = initPlayer(playerElm, idPrefix, options);

	playerPromise.then((player) => {
		//Select resolution for device
		player.ready(function () {
			const groupedSrc = player.getGroupedSrc();

			const playerWidth = getFirstParentValidWidth(playerElm);

			let nextWidth = 0;
			let nextRes = null;

			function getFirstParentValidWidth(element) {
				if (element.innerWidth() !== 0) {
					return element.innerWidth();
				} else if (element.parent() == null) {
					return 0;
				} else {
					return getFirstParentValidWidth(element.parent())
				}
			}

			function calculateMaxWidth() {
				let maxWidth = 0;
				for (var res in groupedSrc.res) {
					if (groupedSrc.res.hasOwnProperty(res)) {
						const splittedRes = res.split('x');
						if (splittedRes.length !== 2) {
							break;
						}
						const width = parseInt(splittedRes[0]);

						if (width > maxWidth) {
							maxWidth = width;
						}
					}
				}

				return maxWidth;
			}

			const maxWidth = calculateMaxWidth(groupedSrc.res);

			const scoreWidth = function(matchWidth, width, maxWidth){
				if(width === matchWidth){
					return maxWidth;
				}else if(width < matchWidth){
					return width - matchWidth;
				}else{
					const maxScore = maxWidth - matchWidth;
					return maxScore - (width - matchWidth);
				}
			}

			const isABetterMatch = function(currentWidth, newWidth){
				const currentScore = scoreWidth(playerWidth, currentWidth, maxWidth);
				const newScore = scoreWidth(playerWidth, newWidth, maxWidth);
				return (newScore > currentScore);
			}

			for (const res in groupedSrc.res) {
				if (groupedSrc.res.hasOwnProperty(res)) {
					const splittedRes = res.split('x');
					if(splittedRes.length !== 2){
						break;
					}
					const width = parseInt(splittedRes[0]);

					let matches = false;
					if(nextRes === null){
						matches = true;
					}else{
						matches = isABetterMatch(nextWidth, width);
					}

					if(matches){
						nextWidth = width;
						nextRes = res;
					}
				}
			}

			if(typeof nextRes !== 'undefined'){
				player.currentResolution(nextRes);
			}

			player.autoplay('any');

			deferred.resolve(player);
		});
	});

	return deferred.promise();
}

function initYoutubePlayer(playerElm, idPrefix, videoId, additionalOptions){
	const options = {
		sources: [{
			src: 'https://www.youtube-nocookie.com/watch?v=' + videoId,
			type: 'video/youtube'
		}],
		youtube: {
			enablePrivacyEnhancedMode: true,
			modestbranding: 1,
			rel: 0,
			showinfo: 0
		},
		techOrder: ['youtube', 'html5'],
		...(additionalOptions ?? {})
	};

	return initPlayer(playerElm, idPrefix, options);
}

let cookiesStatusChangedDeferred = jQuery.Deferred()

const notifyWaitingYoutubePlayers = function (accepted) {
	cookiesStatusChangedDeferred.resolve(accepted);
	cookiesStatusChangedDeferred = jQuery.Deferred();
}

const cookieName = 'youtube';

window.consentChangedCbs.push(function(cookieName, consentAccepted){
	let initialized = false;
	if(cookieName === cookieName){
		if (consentAccepted) {
			notifyWaitingYoutubePlayers(true);
		} else {
			if (initialized) {
				window.location.reload();
			} else {
				notifyWaitingYoutubePlayers(false);
			}
		}

	}
});

function showCookiesOverlay() {
	const deferred = jQuery.Deferred();
	const closedPromise = deferred.promise();

	const dialogElm = jQuery('<div/>');
	jQuery('body').append(dialogElm);


	dialogElm.cookieConsentOverlayWidget({
		title: __('cookieconsentoverlay.youtube.title'),
		cookieName: cookieName,
		cookieInformation: __('cookieconsentoverlay.youtube.description'),
		listeners: {
			onClose: () => {
				deferred.resolve();
			}
		}
	});

	return closedPromise
		.then(() => {
			dialogElm.cookieConsentOverlayWidget('destroy');
			dialogElm.remove();

			return trackingService.isCookieAccepted(cookieName);
		});
}

function initYoutubePlayerWithCookiesCheck(playerElm, idPrefix, videoId, options) {
	if (trackingService.isCookieAccepted(cookieName)) {
		return initYoutubePlayer(playerElm, idPrefix, videoId, options);
	} else {
		return showCookiesOverlay()
			.then((accepted) => {
				if (accepted){
					return initYoutubePlayer(playerElm, idPrefix, videoId);
				} else {
					const deferred = jQuery.Deferred();
					deferred.reject();

					return deferred.promise();
				}
			});
	}
}

export {initYoutubePlayerWithCookiesCheck as youtubePlayerWithCookiesCheck, initVideoPlayer as videoPlayer};
